<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: Teach Your Dog to Talk, by Stephanie Rocha" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781646042760/images/9781646042760.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>Teach Your Dog to Talk</p>
<p>Get talking in just 15 minutes per day!</p>
<p>A Beginner’s Guide to Training Your Dog to Communicate with Word Buttons</p>
<p>Stephanie Rocha</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?783b844f